import { _ } from '@icc/shared/helpers';

export const enum SalesDocumentType {
    Quotation = 1,
    Inquiry = 2,
    Order = 3,
    $QuotationNumberReservation = 4,
    ServiceOrder = 5,
}

export const SalesDocumentTypes = [SalesDocumentType.Quotation, SalesDocumentType.Inquiry, SalesDocumentType.Order, SalesDocumentType.ServiceOrder];
export const SalesDocumentTypeDict = {
    [SalesDocumentType.Quotation]: _('SALES_DOCUMENT|Oferta'),
    [SalesDocumentType.Inquiry]: _('SALES_DOCUMENT|Zapytanie ofertowe'),
    [SalesDocumentType.Order]: _('SALES_DOCUMENT|Zamówienie'),
    [SalesDocumentType.ServiceOrder]: _('SALES_DOCUMENT|Zamówienie serwisowe'),
};
